<app-common-subproducts-hero
  [heroData]="heroHeader"
></app-common-subproducts-hero>
<app-common-subproducts-alternate-blocks
  [featureData]="featureData1"
></app-common-subproducts-alternate-blocks>
<app-common-subproducts-discover-difference
  [differenceData]="differenceData"
  isInside="true"
></app-common-subproducts-discover-difference>
<app-common-subproducts-pricing
  [pricingData]="pricingData"
  [isInside]="true"
></app-common-subproducts-pricing>
<app-common-borderless
  [borderlessData]="borderlessData"
></app-common-borderless>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
